<template>
  <div class="uniformpage flexCloumnSingleCenter">
    <div class="form">
      <div class="cell-group Letter_to_parents">
        <div class="title font24 bloder textCenter">告家长书</div>
        <div class="">各学生及家长：</div>
        <div class="textIndent2">我校自成功创建江苏省四星级中等职业学校、江苏省优质特色职业学校以来，在各方面呈现出良好的发展态势。为了规范学校管理，提高管理质量和效能，现将学生统一着装和使用电子产品管理事宜告之如下：</div>
        <div class="font18 bloder">一、关于学生统一着装的规定</div>
        <div class="textIndent2">
          <span>为了规范学生的仪容仪表，展示学生精神面貌，我校规定：</span>
          <span class="bloder">学生在校期间一律按要求正确穿着校服、佩戴胸卡。</span>
        </div>

        <div class="font18 bloder">二、关于学生使用手机等电子产品管理的规定</div>
        <div class="textIndent2"> 随着科技进歩、社会发展致使学生越来越普遍使用手机进行资讯查阅、资料查阅、人际交往和自我表达，手机的使用一定程度上方便了学生与教师、家长和社会的沟通联系。但由于手机的娱乐功能和交际功能越来越丰富，以及学生心智还不成熟，部分自控力较弱的学生过度使用手机，沉迷于网络游戏和交友聊天，导致学习不专心、视力下降以及亲子关系紧张，严重影响正常的学习、生活和身心健康。</div>
        <div class="textIndent2">学校根据教育部办公厅教基厅函〔2021〕3号文件《关于加强中小学生手机管理工作的通知》、江苏省教育厅办公室苏教办基函〔2021〕8号文件《关于转发教育部办公厅加强中小学生手机管理工作的通知》、常熟市教育局常教转〔2021〕24号文件精神，要求我校学生原则上不得将个人手机带入学校。学生确有将手机带入校园需求的，须经学生家长同意、书面提出申请，进校后应将手机交由系部统一管理，禁止带入课堂。</div>
        <div class="textIndent2">请家长履行教育职责，让孩子科学、理性对待并合理使用手机，提高学生信息素养和自我管理能力，加强对孩子使用手机的督促管理，形成家校协同育人合力。</div>
        <div class="textIndent2 bloder">对确有需要将手机、mp3 、mp4等电子产品带来学校的，每日早读前学生将相关电子产品以班级为单位交至系部代保管，每日放学时领回。（若违反规定，一经发现，一概收缴）</div>
        <div class="textIndent2">对违规使用的手机、mp3、mp4等电子产品或电池充电器处理方法：</div>
        <div class="xuangua bloder">情形一：对违规使用手机等电子产品初犯者，能配合教职工收缴的，问题处理结束后一周，由本人提出书面申请，经班主任、系部同意后，可退还本人。</div>
        <div class="xuangua bloder">情形二：对违规使用手机等电子产品使用规定再犯者，问题处理结束后，需在一个月后，由本人提出书面申请，经班主任提出建议，系部同意后，家长来校领取。</div>
        <div class="xuangua bloder">情形三：对违规使用手机等电子产品屡教不改者，以书面的形式通知家长到校，提出整改意见，一学期结束后由学生家长来校领取。</div>
        <div class="xuangua bloder">另：对于部分违规使用且情节恶劣的学生，学校将视情节给予纪律处分！</div>
        <div class="flexEnd">常熟高新园中等专业学校</div>
        <div class="flexEnd">2021年5月</div>

      </div>
      <div class="cell-group-title flexStart">
        <span style="color: #1283FF">*</span>关于学生在校期间手机使用及穿着校服规定的反馈意见
      </div>
      <div class="cell-group">
        <van-field :readonly="disabled" v-model="editForm.department" label="系部" required
                   placeholder="请输入系部">
        </van-field>
        <van-field :readonly="disabled" v-model="editForm.class" label="班级" required
                   placeholder="请输入班级">
        </van-field>

        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart item-title-required">
            <span class="flexCenter">学生签名</span>
            <el-tag v-if="!disabled" size="small" @click="goSign('isConfirmStu')" class="signBtn">
              {{ !editForm.signUrlStu ? '前往签名' : '修改签名' }}
            </el-tag>
          </div>
          <div style="width: 100%;">
            <div class="item-title flexStart" style="padding-top: 0;padding-bottom: 0;">
              <div style="font-weight: 700; color: #1283FF;">以上规定我已阅读并遵守执行</div>
              <van-checkbox v-model="editForm.isConfirmStu" shape="square" style="margin: 0 0 0 10px;"></van-checkbox>
            </div>
          </div>
          <div class="signUrl-box">
            <img :src="editForm.signUrlStu" mode="aspectFit"></img>
          </div>
        </div>

        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart item-title-required">
            <span class="flexCenter">家长签名</span>
            <el-tag v-if="!disabled" size="small" @click="goSign('isConfirmParent')" class="signBtn">
              {{ !editForm.signUrlParent ? '前往签名' : '修改签名' }}
            </el-tag>
          </div>
          <div style="width: 100%;">
            <div class="item-title flexStart" style="padding-top: 0;padding-bottom: 0;">
              <div style="font-weight: 700; color: #1283FF;">以上规定我已阅读并督促子女遵守执行</div>
              <van-checkbox v-model="editForm.isConfirmParent" shape="square" style="margin: 0 0 0 10px;"></van-checkbox>
            </div>
          </div>
          <div class="signUrl-box">
            <img :src="editForm.signUrlParent" mode="aspectFit"></img>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!disabled" class="submitBtn flexCenter" style="background-color:#fff;">
      <div class="btn btnChange" @click="onSubmitForm">确定</div>
    </div>
    <div v-if="disabled" class="submitBtn flexCenter" style="background-color:#fff;">
      <div class="btn" @click="onModify">点击修改</div>
    </div>
    <div style="width: 100%;height: 100px;background-color:#fff;"></div>

<!--    签名-->
    <div v-if="showhandsign" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);">
      <handSign  @returnImg="getHandSign"></handSign>
    </div>

  </div>
</template>

<script>
import {
  Toast, Dialog
} from 'vant';
import wx from 'weixin-js-sdk'
import handSign from "../../../com/handSign.vue"

export default {
  components: {
    handSign
  },
  // props: {
  //   tableInfo: {
  //     type:Object,
  //     default:{}
  //   },
  //   signUrl: {
  //     type:String,
  //     default:''
  //   },
  //   stu_id:{
  //     type:Number,
  //     default:0
  //   },
  //   pmid: {
  //     type:Number,
  //     default:5
  //   },
  //   signUrlStu: {
  //     type:String,
  //     default:''
  //   },
  //   signUrlParent: {
  //     type:String,
  //     default:''
  //   },
  // },
  data() {
    return {
      editForm: {
        department: '',
        class: '',
        isConfirmStu: false,
        isConfirmParent: false,
        signUrlStu: '',
        signUrlParent: '',
      },
      openid: null,
      disabled: false,
      pmid:5,
      stu_id:0,
      signUrlStu: '',
      signUrlParent: '',
      tableInfo:{},

      showhandsign:false,
      open_type: '',
    }
  },
  mounted() {
    let _this = this
    $(".uniformpage").height($(window).height())//设置页面高度固定，防止输入法弹出页面变形，注意内部元素不能使用vh
    if (this.$route.query) {
      console.log(79, this.$route.query)
      this.stu_id = Number(this.$route.query.stu_id)
      this.pmid = Number(this.$route.query.pmid)
      if(this.$route.query.signurlstu||this.$route.query.signurlparent){
        this.asyncLocalStorage.getItem('editForm').then(r => {
          let editForm = localStorage.getItem('editForm')
          if (editForm) {
            editForm = JSON.parse(editForm)
            //转Boolean
            if(editForm.isConfirmStu=='true'){editForm.isConfirmStu=true}
            if(editForm.isConfirmParent=='true'){editForm.isConfirmParent=true}
            if(editForm.isConfirmStu=='false'){editForm.isConfirmStu=false}
            if(editForm.isConfirmParent=='false'){editForm.isConfirmParent=false}
            _this.editForm = {...editForm}

            if(this.$route.query.signurlstu){
              console.log(1,this.$route.query.signurlstu)
              _this.editForm.signUrlStu = decodeURIComponent(_this.$route.query.signurlstu)
            }
            if(this.$route.query.signurlparent){
              console.log(2,this.$route.query.signurlparent)
              _this.editForm.signUrlParent = decodeURIComponent(_this.$route.query.signurlparent)
            }

            this.editForm = {..._this.editForm}
            console.log(162,_this.editForm)
          }
        })
      }else {
        _this.getList(1)
      }

    }
  },
  methods: {
    getStuInfo(){
      let _this = this
      return new Promise(resolve => {
        this.$http.post("/api/stu_luqu_detail", {
          stu_id: _this.stu_id,
          pmid: this.pmid
        }).then(res => {
          console.log(res.data)
          if(res.data){
            _this.editForm.department = res.data.yuanxi_name
            _this.editForm.major_name = res.data.major_name
            _this.editForm.class = res.data.class_name
            _this.editForm.stuName = res.data.stu_name
            _this.editForm = {..._this.editForm}
            console.log(_this.editForm)
          }
          resolve()
        })
      })
    },

    getList(flag) {
      let _this = this
      return new Promise(resolve => {
        this.$http.post('/api/t_stu_check_in_table_list', {
          pmid: _this.pmid,
          stu_id: _this.stu_id
        }).then(res => {
          for (let item of res.data.data) {
            if (item.table_name.indexOf('校服') != -1) {
              document.title = item.table_name
              _this.tableInfo = item

              if(flag == 1){
                if (item.table_detail) {
                  let detail = JSON.parse(item.table_detail)
                  //转Boolean
                  if(detail.isConfirmStu=='true'){detail.isConfirmStu=true}
                  if(detail.isConfirmParent=='true'){detail.isConfirmParent=true}
                  if(detail.isConfirmStu=='false'){detail.isConfirmStu=false}
                  if(detail.isConfirmParent=='false'){detail.isConfirmParent=false}
                  _this.editForm = Object.assign(detail)
                  _this.disabled = true
                } else {
                  _this.getStuInfo()
                  _this.disabled = false
                }
              }
              console.log(_this.editForm)
              resolve()
              return;
            }
          }
          resolve()
        })
      })

    },

    addOther(action, done) {
      if (action == 'confirm' && this.editForm.otherText) {
        this.editForm.diseases.push(this.editForm.otherText)
      }
      done()
    },
    checkPhone(v) {
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (strTemp.test(v)) {
        return true;
      }
      return false;
    },
    onSubmitForm() {
      let _this = this
      console.log(this.editForm)
      if (!this.editForm.department) {
        Toast('请填写系部');
        return
      }
      if (!this.editForm.class) {
        Toast('请填写班级！');
        return
      }
      if (!this.editForm.signUrlStu) {
        Toast('学生签名不能为空！');
        return
      }

      if (!this.editForm.signUrlParent) {
        Toast('家长签名不能为空！');
        return
      }
      if (!_this.editForm.isConfirmStu) {
        Dialog.alert({
          title: "以上规定我已阅读并遵守执行",
          showCancelButton: true,
          confirmButtonText: "确保真实有效",
          cancelButtonText: "关闭",
          confirmButtonColor: '#1283FF',
        }).then(() => {
          _this.editForm.isConfirmStu = true
        }).catch(() => {
          console.log("点击了取消按钮噢")
        })
      } else if (!_this.editForm.isConfirmParent) {
        Dialog.alert({
          title: "以上规定我已阅读并督促子女遵守执行",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "关闭",
          confirmButtonColor: '#1283FF',
        }).then(() => {
          _this.editForm.isConfirmParent = true
        }).catch(() => {
          console.log("点击了取消按钮噢")
        })
      } else {
        _this.getList(0).then(result=>{
          console.log(_this.tableInfo)
          let params = {}
          params.table_detail = JSON.stringify(_this.editForm)
          params.table_name = _this.tableInfo.table_name
          params.table_code = _this.tableInfo.table_code
          params.stu_id = this.stu_id
          params.table_type_id = _this.tableInfo.type_id
          params.pmid = this.pmid
          if(_this.tableInfo.id){
            params.id = _this.tableInfo.id
          }
          console.log(params)
          this.requestForm(params)
        })

      }
    },
    requestForm(params) {
      let _this = this
      this.$http.post("/api/t_stu_check_in_table_edit", params).then(function (res) {
        if (res.data.id||res.data.message=='') {
          Toast('保存成功！')
          localStorage.removeItem('tableInfo')
          localStorage.removeItem('editForm')
          setTimeout(function (){
            _this.editForm = {}
            wx.miniProgram.navigateBack({
              delta: 1
            })
          },500)
          _this.preExport()
          // wx.miniProgram.navigateTo({
          //   url: `/pages/moreFun/bd/bd`
          // })
        } else {
          Toast(res.data.msg)
          _this.disabled = false
        }
      })

    },

    preExport() {
      let _this = this
      this.$http.post("/api/stu_luqu_detail", {
        stu_id: _this.stu_id,
        pmid: _this.pmid
      }).then(res => {
        console.log(res.data)
        if (res.data.class_id) {
          let params = {
            class_id: _this.editForm.class_id,
            stu_ids: _this.stu_id,
            pmid: _this.pmid,
          }
          _this.$http.post("/api/exportWord1", params).then(function (res) {})
        }

      })


    },

    goSign(name) {
      let _this = this
      console.log(353,this.editForm[name])
      if(!this.editForm[name]){
        Dialog.alert({
          title: `${name=='isConfirmStu'?'以上规定我已阅读并遵守执行！':'以上规定我已阅读并督促子女遵守执行！'}`,
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "关闭",
          confirmButtonColor: '#1283FF',
        }).then(() => {
          _this.editForm[name] = true
        }).catch(() => {
          console.log("点击了取消按钮噢")
        })
      } else {
        _this.open_type = name
        this.showhandsign = true
        return
        this.asyncLocalStorage.setItem('editForm', JSON.stringify(this.editForm)).then(r => {
          console.log('localStorage editForm', localStorage.getItem('editForm'))
          console.log('wx',wx)
          wx.miniProgram.navigateTo({
            url: `/pages/handsign/handsign?from=h5uniform&signtype=${name}`
          })
        })
      }
    },
    getHandSign(e){
      console.log(e)

      this.showhandsign = false
      if(e){
        this.$http.post("/api/save_base64_img",{base64_img:e}).then(res=>{
          if(this.open_type == 'isConfirmStu'){
            this.editForm.signUrlStu = res.data.url
          }else if(this.open_type == 'isConfirmParent'){
            this.editForm.signUrlParent = res.data.url

          }
        })
      }

    },
    onModify() {
      let curTime = new Date().getTime()
      let time1 = new Date(this.tableInfo.cdate).getTime()
      let val = curTime - time1
      this.getDuration(val).then(result => {
            console.log(result.d,result.h)
            if (result.d > 0 || result.h > 3) {
              this.disabled = false
            } else {
              Dialog.alert({
                title: "距上次提交时间小于3小时，请不要频繁修改。",
                showCancelButton: false,
                confirmButtonText: "确定",
                cancelButtonText: "关闭",
                confirmButtonColor: '#1283FF',
              }).then(() => {
                this.disabled = true
              }).catch(() => {
                console.log("点击了取消按钮噢")
              })
            }
          }
      )
      console.log(new Date(), this.tableInfo.cdate, this.tableInfo)
    },
    getDuration(my_time) {
      return new Promise(resolve => {
        var days = my_time / 1000 / 60 / 60 / 24;
        var daysRound = Math.floor(days);
        var hours = my_time / 1000 / 60 / 60 - (24 * daysRound);
        var hoursRound = Math.floor(hours);
        var minutes = my_time / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
        var minutesRound = Math.floor(minutes);
        var seconds = my_time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
        console.log('转换时间:', daysRound + '天', hoursRound + '时', minutesRound + '分', seconds + '秒');
        var time = hoursRound + ':' + minutesRound + ':' + seconds
        let obj = {d:daysRound,h:hoursRound}
        resolve(obj)
        return time;
      })

    },
  },
}
</script>

<style lang="less" type="text/less">
.el-textarea__inner:focus {
  outline: 0;
  border-color: #1283FF !important;
}

.van-radio__icon {
  font-size: 16px;
}
.van-radio__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-checkbox {
  margin-top: 10px;
}
.van-checkbox__icon {
  font-size: 16px;
}
.van-checkbox__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-tag--primary {
  background-color: #1283FF;
}

.van-cell--required::before {
  color: #1283FF !important;
}

.uniformpage {
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #f5f5f5;

  .form {
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    div {
      font-size: 14px;
      color: #323232;
      box-sizing: border-box;
    }

    .Letter_to_parents{
      box-sizing: border-box;
      padding-top: 10px!important;
      .font16{font-size: 16px;}
      .font18{font-size: 18px;}
      .font20{font-size: 20px;}
      .font24{font-size: 24px;}
      .bloder{font-weight: 700}
      .textCenter{text-align: center}
      .textIndent2{text-indent:2em;}
      .xuangua{text-indent:-2em;padding-left:4em}
    }

    .cell-group-title {
      margin: 10px 0 5px 15px;
      font-size: 14px;
      color: #969799;
    }

    .cell-group {
      padding: 0 20px;
      background-color: #fff;
    }

    .topInfo {
      color: #00D1CB;
      font-size: 12px;
    }

    .item-title {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
    }
    .item-title-required::before {
      position: absolute;
      left: 8px;
      color: #1283FF;
      font-size: 14px;
      content: '*';
    }
    .item-input {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px 10px 16px;
      font-size: 14px;
      color: #646566;
    }

    .item-input1 {
      color: #ee0a24;
      font-size: 12px;
      line-height: 18px;
    }

    .item-input1::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }

    .signUrl-box {
      margin-top: 10px;
      border: 1px solid #EEF2F5;
      width: 100%;
      height: 150px;
      padding: 10px;
    }

    .signUrl-box img {
      display: inline-block;
      max-width: 100%;
      max-height: 100%;
    }

    .signBtn {
      margin-left: 10px !important;
      margin-top: 1px;
    }
  }

  .submitBtn {
    padding-top: 6vh;
    width: 100%;

    .btn {
      display: inline-block;
      padding: 1.4vh 0;
      width: 60%;
      text-align: center;
      background-color: #1283FF;
      color: #fff;
      font-size: 15px;
      border-radius: 6px;
    }
  }
}

</style>
